export default {
  expandedPush: 'Expanded push',
  open: 'Open',
  placeholder: 'String of characters{{index}}',
  variable: 'Variable',
  allButtons: 'All options',
  expandButtons: 'Expand buttons',
  allPossibilities: 'See all options',
  selectVariant: 'Choose an option',
  allowCalling: 'Allow calls',
  temporaryAllowCalling: 'Temporarily allow calls',
  allowCallingToDate: 'Allow until {{date}}',
  notNow: 'Not now',
  openMap: '[en] Открыть Яндекс.Карты',
  kilobytes: 'KB',
};
